import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { tap } from 'rxjs';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BillingService {
  private baseUrl = environment.apiUrl;
  http = inject(HttpClient);
  constructor() {}

  getAllProducts() {
    return this.http.get<{ access_token: string }>(
      `${environment.apiUrl}/products`,
    );
  }

  createBill(payload: any) {
    return this.http
      .post(`${environment.billing}`, payload)
      .pipe(tap(() => console.log('Bill created successfully')));
  }

  downloadBill(billId: string) {
    return this.http.get(`${environment.billing}/download/${billId}`, {
      responseType: 'blob',
    });
  }

  getBillingList(limit = 10, page = 1, search?: string): Observable<any[]> {
    const params: any = {
      limit: limit.toString(),
      page: page.toString(),
    };
    if (search) {
      params.search = search;
    }
    return this.http.get<any[]>(`${this.baseUrl}/billing`, { params });
  }

  getBillingById(id: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/billing/${id}`);
  }

  exportCsv(payload: {
    preset?: string;
    fromDate?: string;
    toDate?: string;
  }): Observable<Blob> {
    // Build payload dynamically → only include keys that exist
    const body: any = {};
    if (payload.preset) body.preset = payload.preset;
    if (payload.fromDate) body.fromDate = payload.fromDate;
    if (payload.toDate) body.toDate = payload.toDate;

    return this.http.post(`${this.baseUrl}/billing/export-csv`, body, {
      responseType: 'blob',
    });
  }

  getBillingReport(payload: {
    preset?: string;
    fromDate?: string;
    toDate?: string;
  }): Observable<any[]> {
    const body: any = {};
    if (payload.preset) body.preset = payload.preset;
    if (payload.fromDate) body.fromDate = payload.fromDate;
    if (payload.toDate) body.toDate = payload.toDate;

    return this.http.post<any[]>(`${this.baseUrl}/billing/report`, body);
  }
}
